import React, { useEffect, useState } from 'react';
import styles from './bomListTable.module.css';
import { Downarrow, EditPart, Leaf, Paginationleft, Paginationright, Pdf, trash, Uparrow } from '../../../../Svg';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { deleteAlterProduct, getAlterProductsThunk, setSelectedProducts, updateQuantity } from '../../../redux/bomSlice';
import { setLoginpopup } from '../../../redux/customerSlice';
import { stripHtmlTags } from '../../../utils/utils';

const WizardTable = ({ products, setProducts, from, handleCheckboxChange, addtoCart, quantities, cartLoading, scheduleLoading, handleQuantityChange, handleSelectAlternate, editingProduct, handleSubmit, newPartNumber, addMoreData, setNewPartNumber, handleEditClick, setProductData, productData, setShowLogin, isLoggedin, submitLoading, handleUpload }) => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [expandedProducts, setExpandedProducts] = useState({});
    const { alterLoading, alterProducts, selectedProducts } = useSelector((state) => state.bom)
    const productnumber = alterProducts?.productnumber || []

    const toggleShowAll = (productId) => {
        setExpandedProducts((prev) => ({
            ...prev,
            [productId]: !prev[productId],
        }));
    };









    const handleChange = (product, e) => {
        console.log(product?.product);
        const pn = product?.productNumber != null ? String(product.productNumber).trim() : undefined;
        const pNum = product?.productNumber ? String(product.productNumber).trim() : '';

        const isExist = selectedProducts?.find(i => {
            if (i?.productNumber === undefined && pn === undefined) return false;
            return i?.productNumber === pn || (i?.productNumber ? String(i.productNumber).trim() : '') === pNum;
        });
        console.log(isExist, "ss");
        if (isExist) {
            const filter = selectedProducts?.filter((i) => {
                if (i?.productNumber === undefined && pn === undefined) return true;
                return i?.productNumber !== pn && (i?.productNumber ? String(i.productNumber).trim() : '') !== pNum;
            });
            return dispatch(setSelectedProducts(filter))
        }
        const data = [...selectedProducts, { productNumber: pn != null ? pn : pNum, quantity: product?.quantity || 1, manufacturer: product?.product?.productOverview?.manufacturer?.[0]?.name || product?.manufacturer || 'n/a', product: product?.product }]
        dispatch(setSelectedProducts(data))
    }

    const handleSelectAllChange = (checked) => {
        if (checked) {
            const allSelected = products.map(product => {
                const pNum = product?.productNumber ? String(product.productNumber).trim() : '';
                return {
                    productNumber: pNum,
                    quantity: product?.quantity || 1,
                    manufacturer: product?.product?.productOverview?.manufacturer?.[0]?.name || product?.manufacturer || 'n/a',
                    product: product?.product
                };
            });
            dispatch(setSelectedProducts(allSelected));
        } else {
            dispatch(setSelectedProducts([]));
        }
    };

    console.log(selectedProducts);

    const handleQuantity = (productNumber, quantities) => {
        const pNum = productNumber ? String(productNumber).trim() : '';
        if (setProducts) {
            setProducts((currentProducts) => currentProducts.map((product) =>
                normPN(product?.productNumber) === normPN(productNumber)
                    ? { ...product, quantity: parseInt(quantities, 10) || '' }
                    : product
            ))
        }
        dispatch(updateQuantity({
            productNumber: productNumber != null ? String(productNumber).trim() : pNum,
            quantity: quantities
        }))
    }


    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allSelected = products.map(product => {
                const productNumber = product?.productNumber != null
                    ? String(product.productNumber).trim()
                    : undefined;
                return {
                    productNumber,
                    quantity: product?.quantity || 1,
                    manufacturer: product?.product?.productOverview?.manufacturer?.[0]?.name || product?.manufacturer || 'n/a',
                    product: product?.product
                };
            }).filter(item => item.productNumber);

            const newSelection = [...selectedProducts];
            allSelected.forEach(item => {
                if (!newSelection.some(i => i.productNumber === item.productNumber)) {
                    newSelection.push(item);
                }
            });
            dispatch(setSelectedProducts(newSelection));
        } else {
            const filter = selectedProducts?.filter(
                (i) => !products.some(product => {
                    const pn = product?.productNumber != null
                        ? String(product.productNumber).trim()
                        : undefined;
                    return pn === i?.productNumber;
                })
            );
            dispatch(setSelectedProducts(filter));
        }
    };

    const normPN = (pn) => pn != null ? String(pn).trim() : undefined;

    const allSelected = products?.length > 0 && products.every(product =>
        selectedProducts?.some(i => i?.productNumber === normPN(product?.productNumber))
    );

    return (
        <>
            <div className={styles.sortedTable}>
                <div className={styles.selectAllBar}>
                    <button
                        className={styles.selectAllBtn}
                        onClick={(e) => handleSelectAll({ target: { checked: true } })}
                    >
                        Select All
                    </button>
                    <button
                        className={styles.deselectAllBtn}
                        onClick={(e) => handleSelectAll({ target: { checked: false } })}
                        disabled={selectedProducts?.length === 0}
                    >
                        Deselect All
                    </button>
                    {selectedProducts?.length > 0 && (
                        <span className={styles.selectedCount}>
                            {selectedProducts.length} item{selectedProducts.length !== 1 ? 's' : ''} selected
                        </span>
                    )}
                </div>
                <div className={styles.productTableContainer}>
                    <table className={styles.productTable} style={{ background: '#F1F1F1' }}>
                        <thead className={styles.productTableHead}>
                            <tr>
                                <th className={styles.compare}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'flex-start', paddingLeft: 8 }}>
                                        <input 
                                            type="checkbox"
                                            checked={products?.length > 0 && products.every(p => p?.productNumber != null && selectedProducts?.some(s => s?.productNumber != null && String(s?.productNumber).trim() === String(p?.productNumber).trim()))}
                                            ref={(el) => {
                                                if (el) {
                                                    const isSomeSelected = products?.some(p => p?.productNumber != null && selectedProducts?.some(s => s?.productNumber != null && String(s?.productNumber).trim() === String(p?.productNumber).trim()));
                                                    const isAllSelected = products?.length > 0 && products.every(p => p?.productNumber != null && selectedProducts?.some(s => s?.productNumber != null && String(s?.productNumber).trim() === String(p?.productNumber).trim()));
                                                    el.indeterminate = isSomeSelected && !isAllSelected;
                                                }
                                            }}
                                            onChange={(e) => handleSelectAllChange(e.target.checked)}
                                            style={{ cursor: 'pointer' }}
                                        />
                                        <span>#</span>
                                    </div>
                                </th>
                                <th className={styles.dataSheet}>Data sheet</th>
                                <th className={styles.partNumber}>
                                    <div className={styles.headerWithFilter}>
                                        <span>Part </span>
                                        <div className={styles.sortIcons}>
                                            <Uparrow />
                                            <Downarrow />
                                        </div>
                                    </div>
                                </th>
                                <th className={styles.manufacturer}>
                                    <div className={styles.headerWithFilter} style={{ justifyContent: 'center' }}>
                                        <span>Manufacturer</span>
                                        <div className={styles.sortIcons}>
                                            <Uparrow />
                                            <Downarrow />
                                        </div>
                                    </div>
                                </th>
                                <th className={styles.stock}>
                                    <div className={styles.headerWithFilter} style={{ justifyContent: 'center' }}>
                                        <span>Available Stock</span>
                                        <div className={styles.sortIcons}>
                                            <Uparrow />
                                            <Downarrow />
                                        </div>
                                    </div>
                                </th>
                                <th className={styles.unitPrice} style={{ textAlign: 'center' }}>Unit Price</th>
                                <th className={styles.requiredQuantity} style={{ textAlign: 'center' }}>Required Quantity</th>
 
                            </tr>
                        </thead>
                        <tbody >
                            <>
                                {products?.map((product, index) => (
                                    <>
                                        <tr key={product?.productNumber} style={{ backgroundColor: product?.productNumber == productnumber ? '#F1F1F1' : '#ffffff' }}>
                                            <td className={`${styles.compare}  ${styles.tdBorder}`} >
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                    <input type="checkbox"
                                                        onChange={(e) =>
                                                            handleChange(product, e)
                                                        }
                                                        checked={product?.productNumber != null && selectedProducts?.some(i => i?.productNumber != null && String(i?.productNumber).trim() === String(product?.productNumber).trim())}
                                                    />
                                                    <div style={{ color: '#222222' }}>

                                                        {index + 1}
                                                    </div>
                                                </div>
                                            </td>
                                            <td className={`${styles.dataSheet}  ${styles.tdBorder}`}>

                                                {product?.status ?
                                                    <div className={styles.dataCol}>
                                                        <a href={product?.product?.productOverview?.datasheetUrl[0]} target='_blank'>
                                                            <Pdf />
                                                        </a>
                                                        <Leaf />
                                                    </div>
                                                    :
                                                    <div style={{ color: '#94a3b8' }}>-</div>
                                                }
                                            </td>
                                            <td className={`${styles.partNumber}  ${styles.tdBorder}`}>

                                                <div className={styles.dataRow}>
                                                    {product?.status ?
                                                        <>
                                                            <img src={product?.product?.assets?.featuredImage[0]} style={{ width: 32, height: 32 }} />
                                                            <div className={styles.dataCol}>
                                                                {editingProduct === product.productNumber ?
                                                                    <div style={{ display: 'flex' }}>
                                                                        <input
                                                                            type="text"
                                                                            className={styles.dataInput}
                                                                            value={newPartNumber}
                                                                            onChange={(e) => setNewPartNumber(e.target.value)}
                                                                        />

                                                                        <button onClick={handleSubmit} className={styles.addButton}>Submit</button>

                                                                    </div>
                                                                    :
                                                                    <div className={styles.displayFlex} >
                                                                        <div className={styles.dataColorChange} onClick={() => navigate(`/productCode/${product?.productNumber}`)} style={{ cursor: 'pointer' }}>{product?.productNumber}</div>
                                                                        {/* <div onClick={() => handleEditClick(product?.productNumber)} style={{ cursor: 'pointer' }}>
                                                                            <EditPart />
                                                                        </div> */}
                                                                    </div>
                                                                }
                                                                <div>{stripHtmlTags(product?.product?.productOverview?.description?.[0] || product?.product?.description)}</div>
                                                                {/* <div style={{ display: 'flex', gap: 10 }}>
                                                                    <div disabled={alterLoading} onClick={() => searchAlter(product?.productNumber)} style={{ textDecoration: 'underline', color: '#512DA8', cursor: 'pointer' }}>Search Alternate</div>
                                                                    {alterLoading &&
                                                                        <div>
                                                                            <img src="/assets/__Iphone-spinner-1.gif" alt="" style={{ width: 25, height: 25 }} />
                                                                        </div>
                                                                    }
                                                                </div> */}
                                                            </div>
                                                        </>
                                                        :
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 3 }}>
                                                            <span style={{ color: '#000000', fontSize: 12, fontWeight: 500 }}>{product?.productNumber}</span>
                                                            <span style={{ color: '#B45309', background: '#FEF3C7', fontSize: 10, fontWeight: 600, padding: '1px 6px', borderRadius: 4, whiteSpace: 'nowrap' }}>No exact match</span>
                                                        </div>
                                                    }
                                                </div>
                                            </td>
                                            <td className={`${styles.manufacturer}  ${styles.tdBorder}`} style={{ textAlign: 'center', verticalAlign: 'middle', alignContent: 'center' }}>
                                                {/* Catalogue manufacturer, else the one from the uploaded sheet */}
                                                {(product?.product?.productOverview?.manufacturer?.[0]?.name || product?.manufacturer) ?
                                                    <div className={styles.dataColorChange} style={{ textAlign: 'center' }}>
                                                        {product?.product?.productOverview?.manufacturer?.[0]?.name || product?.manufacturer}
                                                    </div>
                                                    :
                                                    <div style={{ color: '#94a3b8', textAlign: 'center' }}>-</div>
                                                }
                                            </td>



                                            <td className={`${styles.stock}  ${styles.tdBorder}`}>
                                                {product?.status ?
                                                    <>

                                                        <div style={{ color: '#222222', fontWeight: 700 }}>
                                                            {product?.product?.inventory?.qtyAvailable}
                                                        </div>
                                                        <div className={styles.dataMargin}>{product?.product?.inventory?.qtyAvailable > 0 ? "in stock" : "out of stock"}</div>
                                                        {product?.product?.inventory?.factoryStock ?
                                                            <>

                                                                <div style={{ color: '#222222', fontWeight: 700 }}>
                                                                    {product?.product?.inventory?.factoryStock}
                                                                </div>
                                                                <div className={styles.dataMargin}>factoryStock</div>
                                                            </>
                                                            : null}
                                                        <div>CanShip Immediately: <span style={{ color: '#222222', fontWeight: 700 }}>{product?.product?.inventory?.canShipImmediately ? 'YES' : 'NO'}</span> </div>
                                                    </>
                                                    :
                                                    <div style={{ color: '#94a3b8' }}>-</div>
                                                }
                                            </td>
                                            <td className={`${styles.unitPrice}  ${styles.tdBorder}`} style={{ textAlign: 'center', verticalAlign: 'middle', alignContent: 'center' }}>
                                                {product?.status ?
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', textAlign: 'center' }}>
                                                        {product?.product?.quantityTable
                                                            ?.slice(
                                                                0,
                                                                expandedProducts[product?.product?._id]
                                                                    ? product?.product?.quantityTable?.length
                                                                    : 2
                                                                )
                                                            .map((i, index) => (
                                                                <div key={index} className={styles.dataMargin} style={{ textAlign: 'center' }}>
                                                                    {i?.breakQty}: <span style={{ color: '#222222', fontWeight: 700 }}>₹{i?.unitPrice}</span>
                                                                    <div style={{ textAlign: 'center' }}>
                                                                        {i?.packaging}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        {product?.product?.quantityTable?.length > 2 && (
                                                            <a
                                                                href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault(); // Prevent page reload
                                                                    toggleShowAll(product?.product?._id);
                                                                }}
                                                                style={{ textAlign: 'center' }}
                                                            >
                                                                <div className={styles.dataColorChange} style={{ textAlign: 'center' }}>
                                                                    {expandedProducts[product?.product?._id]
                                                                        ? "Show Less"
                                                                        : "More Inventory"}
                                                                </div>
                                                            </a>
                                                        )}
                                                    </div>
                                                    :
                                                    <div style={{ color: '#94a3b8', textAlign: 'center' }}>-</div>
                                                }
                                            </td>
                                            <td className={`${styles.requiredQuantity}  ${styles.tdBorder}`}>
                                                {product?.status ?
                                                    <>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter qty"
                                                            className={styles.dataInput}
                                                            // value={quantities[product?.productNumber] || ""}
                                                            value={product?.quantity || ''}

                                                            onChange={(e) => handleQuantity(product?.productNumber, e.target.value)}
                                                        />
                                                        <div className={styles.dataMargin}>Min {product?.product?.inventory?.minimumMultiplier || 1}</div>
                                                        {/* <div className={styles.dataCol}>
                                                            <button
                                                                className={styles.addButton}
                                                                disabled={!quantities[product?.productNumber] || quantities[product?.productNumber] <= 0}
                                                                onClick={() => addtoCart('cart', product?.productNumber)}
                                                                style={{ cursor: 'pointer'}}
                                                            >
                                                                {cartLoading[product?.productNumber] ? 'Please wait...' : '+ Add to cart'}
                                                            </button>
                                                            <button
                                                                className={styles.scheduleButton}
                                                                disabled={!quantities[product?.productNumber] || quantities[product?.productNumber] <= 0}
                                                                onClick={() => addtoCart('schedule', product?._id)}
                                                                style={{ cursor: 'pointer'}}

                                                            >
                                                                {scheduleLoading[product?.productNumber] ? 'Please wait...' : '+ Add to schedule'}
                                                            </button>
                                                        </div> */}
                                                    </>
                                                    :

                                                    <>
                                                        <input
                                                            type="text"
                                                            className={styles.dataInput}
                                                            style={{ background: 'white' }}
                                                            value={product?.quantity || 1}
                                                            onChange={(e) => handleQuantity(product?.productNumber, e.target.value)}
                                                        />
                                                    </>
                                                }
                                            </td>
                                        </tr>

                                    </>
                                ))}

                            </>
                        </tbody>
                    </table>
                    {/* <div style={{ marginTop: '20px' }}>
                        <form action="" onSubmit={(e) => addMoreData(newInput, e)}>
                            <input type='text' placeholder='Add Part number' className={styles.dataInput} onChange={(e) => setNewInput(e.target.value)} />
                            <span>Or</span>
                            <button className={styles.compareBtn}>Bulk Add</button>
                        </form>
                    </div> */}
                </div>
            </div>
            {selectedProducts?.length > 0 &&
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 20 }}>
                    {/* <div>
                        <button className={styles.quoteBtn} onClick={handleDelete}>Delete</button>
                    </div> */}
                    {/* <div className={styles.listingBtns}> */}
                    <button className={styles.quoteBtn} onClick={() => {
                        if (!isLoggedin) {
                            dispatch(setLoginpopup(true))
                            return setShowLogin(true)
                        }
                        if (from == "excess") {
                            // navigate(`/exInventEnquiryForm`,{state:selectedProducts})
                            handleUpload(selectedProducts)
                        } else {
                            navigate(`/wizardEnquiryForm`, { state: selectedProducts })
                        }

                    }}
                    >
                        {submitLoading ? "please wait..." : "Submit"}
                    </button>
                    {/* <div className={styles.divide}></div> */}

                    {/* </div> */}
                </div>
            }
        </>
    );
};

export default WizardTable;
